"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const react_router_1 = require("react-router");
const FormErrors_1 = __importDefault(require("../../../pageParts/FormErrors"));
const Auth_1 = require("../../../../actions/Auth");
const Button_1 = __importDefault(require("../../../input/Button"));
const LoginPage = ({ withForgotPassword = false, headerText }) => {
    const { t } = (0, react_i18next_1.useTranslation)('auth');
    const dispatch = (0, react_redux_1.useDispatch)();
    const location = (0, react_router_1.useLocation)();
    const navigate = (0, react_router_1.useNavigate)();
    const submitButtonRef = react_1.default.useRef(null);
    const isAuthenticated = (0, react_redux_1.useSelector)((state) => state.auth.isAuthenticated);
    const login = (0, react_redux_1.useSelector)((state) => state.auth.login);
    const [formState, setFormState] = react_1.default.useState({
        usernameOrEmail: '',
        password: '',
        error: undefined
    });
    const validateForm = () => {
        if (!formState.usernameOrEmail) {
            return t('auth:missingUsernameOrEmail');
        }
        if (!formState.password) {
            return t('auth:missingPassword');
        }
        return undefined;
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormState((prev) => (Object.assign(Object.assign({}, prev), { [name]: name === 'usernameOrEmail' ? value.replaceAll(' ', '') : value })));
    };
    const handleSubmit = () => {
        const error = validateForm();
        if (error) {
            setFormState((prev) => (Object.assign(Object.assign({}, prev), { error })));
            return;
        }
        setFormState((prev) => (Object.assign(Object.assign({}, prev), { error: undefined })));
        dispatch((0, Auth_1.startLogin)({
            usernameOrEmail: formState.usernameOrEmail,
            password: formState.password
        }, location, navigate));
    };
    const handleEnterKeyPress = (e) => {
        var _a;
        // Submit form on 'Enter' inside the element
        if (e.key === 'Enter') {
            (_a = submitButtonRef.current) === null || _a === void 0 ? void 0 : _a.click();
        }
    };
    return (react_1.default.createElement("form", { className: "apptr__form apptr__form-auth", onSubmit: (e) => e.preventDefault() },
        react_1.default.createElement("div", { className: "apptr__form-label-container center" },
            react_1.default.createElement("div", { className: "apptr__form__label-standalone no-question" },
                react_1.default.createElement("p", null, headerText || t('auth:pleaseEnterLoginCredentials'))),
            formState.error && react_1.default.createElement(FormErrors_1.default, { errors: [formState.error] }),
            login && !isAuthenticated && react_1.default.createElement(FormErrors_1.default, { errors: ['auth:authenticationFailed'] })),
        react_1.default.createElement("div", { className: "apptr__form-container question-empty" },
            react_1.default.createElement("div", { className: "apptr__form-input-container" },
                react_1.default.createElement("label", { htmlFor: "usernameOrEmail", className: "_flex" }, t('auth:UsernameOrEmail')),
                react_1.default.createElement("input", { name: "usernameOrEmail", id: "usernameOrEmail", type: "text", className: "apptr__form-input apptr__form-input-string apptr__input apptr__input-string", autoFocus: true, value: formState.usernameOrEmail, onChange: handleInputChange }))),
        react_1.default.createElement("div", { className: "apptr__form-container question-empty" },
            react_1.default.createElement("div", { className: "apptr__form-input-container" },
                react_1.default.createElement("label", { htmlFor: "password", className: "_flex" }, t('auth:Password')),
                react_1.default.createElement("input", { name: "password", id: "password", type: "password", className: "apptr__form-input apptr__form-input-string apptr__input apptr__input-string", value: formState.password, onChange: handleInputChange, onKeyUp: handleEnterKeyPress }),
                withForgotPassword && (react_1.default.createElement("div", { className: "right _small" },
                    react_1.default.createElement(react_router_1.Link, { className: "_oblique", to: "/forgot" }, t('auth:forgotPassword')))))),
        react_1.default.createElement(Button_1.default, { type: "submit", isVisible: true, onClick: handleSubmit, inputRef: submitButtonRef, label: t('auth:Login') })));
};
exports.default = LoginPage;
//# sourceMappingURL=LoginForm.js.map